import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const DashBoardAdminRoutes = [
    {
        path: '/admin',
        component: React.lazy(() => import('./DashboardAdmin.js')),
        auth: AuthRoles.sa,
    }
]

export default DashBoardAdminRoutes;
